import React from 'react';
import classnames from 'classnames';
import Icon from '../Icon/Icon';

import './Link.scss';

export interface LinkProps {
    /**
     * Href attr
     */
    href?: string;
    /**
     * Color of the link
     */
    color?: 'primary' | 'secondary' | 'tertiary' | 'accent' | 'success' | 'warning' | 'error' | 'info';
    /**
     * Underline link
     */
    underline?: boolean;
    /**
     *  Icon left
     */
    iconLeft?: string;
    /**
     *  Icon right
     */
    iconRight?: string;
    /**
     *  Icon size
     */
    iconSize?: string | number;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style
     */
    style?: any;
    /**
     * Function called on click button
     */
    onClick?(e: any): any;
    /**
     * Slot component
     */
    children?: React.ReactNode;
    /**
     * Other props
     */
    [otherProps: string]: any;
}

const Link: React.FC<LinkProps> = ({
    href = '#!',
    color,
    underline = false,
    iconLeft,
    iconRight,
    iconSize,
    className,
    style = {},
    children,
    onClick,
    ...otherProps
}) => {
    const handleClick = (e: any) => {
        if (e && onClick) {
            e.preventDefault();
            onClick(e);
        }
    };

    const classNames = classnames(['link', color, { underline }, className]);

    return (
        <a href={href} className={classNames} style={style} onClick={handleClick} {...otherProps}>
            {iconLeft ? <Icon name={iconLeft} size={iconSize} color={color} className="link__icon--left" /> : null}
            {children}
            {iconRight ? <Icon name={iconRight} size={iconSize} color={color} className="link__icon--right" /> : null}
        </a>
    );
};

export default Link;
